import { Actions, ActionTypes } from "./actions";
import { State, getInitialState } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.setTravelPurpose:
      return {
        ...state,
        travelPurpose: action.payload
      };
    default:
      return state;
  }
};

export { reducer, getInitialState };
